import { render } from "./ScanTrailer.vue?vue&type=template&id=215094fb&scoped=true&ts=true"
import script from "./ScanTrailer.vue?vue&type=script&lang=ts"
export * from "./ScanTrailer.vue?vue&type=script&lang=ts"

import "./ScanTrailer.vue?vue&type=style&index=0&id=215094fb&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215094fb"]])

export default __exports__